(function() {
    function funcReady() {
        $('.subRenewWrap ').addClass('subRenewWrap--story');
        $('.sub-renew-nav-wrap').find('.mobile-nav-button').after('<div class="nav-story-wrap"><button type="button" class="btn-story" onclick="location.href=\'/story\';"><span> 스토리홈</span></button></div>');
        $('.KRP0016').buildCommonUI();
        //lgkorUI.loadKakaoSdkForShare(); //BTOCSITE-5938-363 [모니터링] 스토리 > 가이드&팁 공유하기 url복사 두번 호출 오류
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0016', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0016')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0016')) return false;
        funcReady();
    });
})();

